export default __webpack_public_path__ + "static/media/step_circle.2c20a2ff.svg";